"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.syntheticProcess = exports.remove = exports.add = void 0;
const utils = __importStar(require("../dbNodes/utils"));
const helpers_1 = require("./helpers");
// Before:
// +------------------------+                +-----------------------+
// |                        |                |                       |
// |  waitForDataLakeTable  +--------------->| WhatEver              |
// |                        |                |                       |
// +------------------------+                +-----------------------+
// After:
// +------------------------+                +-----------------------+                +-----------------------+
// |                        |                |                       |                |                       |
// |  waitForDataLakeTable  +--------------->| UserInputNeeded       |--------------->| WhatEver              |
// |                        |                |                       |                |                       |
// +------------------------+                +-----------------------+                +-----------------------+
// create a synthetic node userInputNeeded which goes between
// waitForDataLakeTable => userInputNeeded => Whatever.
//
// for each artifact of type "waitForDataLakeTable"
//  1. create a new artifact of type "userInputNeeded"
//  2. create a new dependency between waitForDataLakeTable => userInputNeeded
//  For each output of waitForDataLakeTable
//      3. create a new dependency between userInputNeeded => whatever
//      4. remove the dependency between waitForDataLakeTable => whatever
const add = (dbGraph) => (0, helpers_1.interposeUserInputGate)({
    dbGraph,
    anchors: utils.filterWaitForDataLakeTables(dbGraph),
    inputType: 'dataLakeTableHydration',
});
exports.add = add;
// Before:
// +------------------------+                +------------------------+                +-----------------------+
// |                        |                |                        |                |                       |
// |  waitForDataLakeTable  +--------------->| UserInputNeeded        |--------------->| WhatEver              |
// |                        |                |(dataLakeTableHydration)|                |                       |
// +------------------------+                +------------------------+                +-----------------------+
// After:
// +------------------------+                +-----------------------+
// |                        |                |                       |
// |  waitForDataLakeTable  +--------------->| WhatEver              |
// |                        |                |                       |
// +------------------------+                +-----------------------+
// for each artifact of type "userInputNeeded" which has inputType "dataLakeTableHydration"
//  1. find the artifact which is connected to this artifact.
//  2. remove the dependency between userInputNeeded => whatever
//  3. create a new dependency between waitForDataLakeTable => whatever
//  4. remove the userInputNeeded artifact
const remove = (dbGraph) => (0, helpers_1.removeUserInputGate)({
    dbGraph,
    gates: utils.filterUserInputNeededNodesByInputType(dbGraph, 'dataLakeTableHydration'),
    inputType: 'dataLakeTableHydration',
});
exports.remove = remove;
exports.syntheticProcess = {
    toDb: exports.add,
    fromDb: exports.remove,
};
//# sourceMappingURL=datalakeWaitUserInput.js.map